<form [formGroup]="form">
  <span class="tw-space-x-5">
    <mat-slide-toggle
      formControlName="newMold"
      class="tw-my-3"
      *ngIf="showControls.newMold"
      >Crear nuevo molde</mat-slide-toggle
    >
    <mat-slide-toggle
      *ngIf="showControls.serialized"
      formControlName="serialized"
      class="tw-my-3"
    >
      Molde serializado
    </mat-slide-toggle>
  </span>

  <mat-form-field
    appearance="outline"
    class="half-width"
    *ngIf="!newMoldToggle && !onEdit"
  >
    <mat-label>Molde</mat-label>
    <mat-select formControlName="name">
      <mat-option>
        <ngx-mat-select-search
          formControlName="searchMold"
          placeholderLabel="Buscar..."
          noEntriesFoundLabel="Sin resultados"
        >
        </ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let loc of moldsFiltered$ | async" [value]="loc.name">
        {{ loc.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field
    appearance="outline"
    *ngIf="newMoldToggle || onEdit"
    class="half-width"
  >
    <mat-label>Nombre del molde</mat-label>
    <input type="text" matInput formControlName="name" />
  </mat-form-field>
  <mat-form-field
    appearance="outline"
    class="half-width"
    *ngIf="moldTypes.length > 0"
  >
    <mat-label>Tipo</mat-label>
    <mat-select formControlName="moldType">
      <mat-option *ngFor="let type of moldTypes" [value]="type.id">
        {{ type.title }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field
    appearance="fill"
    disabled="true"
    class="half-width"
    *ngIf="showControls.cavities"
  >
    <mat-label>Numero de cavidades</mat-label>
    <input type="number" matInput formControlName="cavities" />
  </mat-form-field>
  <mat-form-field appearance="fill" disabled="true" class="half-width">
    <mat-label>Ciclos necesarios para mandar a reparar</mat-label>
    <input type="number" matInput formControlName="cyclesToRepair" />
  </mat-form-field>
  <mat-form-field appearance="fill" disabled="true" class="half-width">
    <mat-label>Ciclos para que el molde se vuelva obsoleto</mat-label>
    <input type="number" matInput formControlName="cyclesToObsolete" />
  </mat-form-field>
  <mat-form-field
    appearance="outline"
    class="half-width"
    *ngIf="showControls.assembly"
  >
    <mat-label>Numero de parte</mat-label>
    <input
      type="text"
      matInput
      formControlName="assembly"
      [matAutocomplete]="auto"
      (input)="onSearchInput($event)"
    />
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option *ngFor="let option of filteredOptions" [value]="option.title">
        {{ option.title }}
      </mat-option>
    </mat-autocomplete>

    <mat-error *ngIf="form.get('assembly')?.hasError('required')">
      Este campo es obligatorio.
    </mat-error>
    <mat-error *ngIf="form.get('assembly')?.hasError('invalidAssembly')">
      Debes seleccionar una opción válida de la lista.
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="half-width">
    <mat-label>Imagen del molde</mat-label>

    <input
      matInput
      formControlName="imageName"
      placeholder="Seleccionar imagen"
      readonly
    />

    <button
      mat-icon-button
      matSuffix
      type="button"
      (click)="fileInput.click()"
      [disabled]="form.get('image')?.disabled"
      aria-label="Seleccionar imagen"
    >
      <i class="pi pi-images tw-mb-2" style="font-size: 1.5rem"></i>
    </button>

    <input
      #fileInput
      type="file"
      hidden
      accept="image/*"
      (change)="onImageSelected($event)"
      [disabled]="form.get('image')?.disabled"
    />

    <mat-hint>JPG o PNG · máx 5MB</mat-hint>
  </mat-form-field>

  <span>
    <button
      mat-raised-button
      class="app-btn-blue"
      [disabled]="!form.valid"
      (click)="finishForm()"
    >
      Siguiente
    </button>
  </span>
</form>
